<!-- eslint-disable vue/multi-word-component-names -->
<template>
    <div class="hox-container">
        <slot />
    </div>
</template>

<style lang="scss">
.hox-container {
    padding: 0 100px;
    width: 100%;
}
</style>
